'use client';

import { useEffect, useRef, useState } from 'react';

/**
 * 版本检测:部署后浏览器里停留的旧会话(旧 JS chunk)在 SPA 导航时会因
 * Server Action / chunk 版本不匹配而崩溃。此组件轮询后端 buildId,
 * 发现平台已更新时提示用户刷新,避免在操作中途弹出 Application error。
 */
export default function VersionPing() {
  const [stale, setStale] = useState(false);
  const [zh, setZh] = useState(true);
  const baseRef = useRef<string | null>(null);

  useEffect(() => {
    // Follow the persisted user language (AiLumix-store.state.language);
    // <html lang> is a static default and a naive string search would also
    // match user.language.
    try {
      const obj = JSON.parse(localStorage.getItem('AiLumix-store') || '{}');
      setZh(obj?.state?.language !== 'en');
    } catch {
      setZh(false);
    }
  }, []);

  useEffect(() => {
    let timer: number;
    const ping = async () => {
      try {
        const r = await fetch('/api/v1/market/build-version', { cache: 'no-store' });
        const j = await r.json();
        if (!j || typeof j.buildId !== 'string' || !j.buildId) return;
        if (baseRef.current === null) {
          baseRef.current = j.buildId;
          return;
        }
        if (j.buildId !== baseRef.current) setStale(true);
      } catch {
        /* 瞬时网络错误忽略,下轮再试 */
      }
    };
    ping();
    timer = window.setInterval(ping, 90_000);
    return () => window.clearInterval(timer);
  }, []);

  if (!stale) return null;

  return (
    <div className="fixed bottom-20 left-1/2 z-[99] -translate-x-1/2 sm:bottom-6">
      <div className="flex items-center gap-3 rounded-full border border-gf-accent/40 bg-gf-surface2/95 px-4 py-2 shadow-2xl backdrop-blur">
        <span className="text-xs font-medium text-gf-text">
          {zh ? '平台已更新至新版本' : 'A new version is available'}
        </span>
        <button
          onClick={() => window.location.reload()}
          className="rounded-full bg-gf-accent px-3 py-1 text-xs font-semibold text-white transition-opacity hover:opacity-85"
        >
          {zh ? '立即刷新' : 'Refresh now'}
        </button>
      </div>
    </div>
  );
}
